/**
 * primaLettura.js — la lettura con cui una pagina si apre riprova da sola UNA
 * volta, dopo 2 secondi, se la risposta non e' arrivata (Claude, 3/11/2026,
 * dopo «Non riesco a leggere il catalogo» di Alex alle 10:05).
 *
 * PERCHE'. Con i rilasci di giorno (regola del 31/10) il backend si riavvia
 * con la clinica aperta, e per un secondo e mezzo Nginx risponde 502: il
 * 3/11 alle 10:05 erano 10 risposte in tutta la clinica, quattro della
 * pagina del catalogo aperta da Alex proprio allora. La pagina diceva un
 * testo generico e restava cosi'. Un solo tentativo, dopo 2 s, copre il
 * fermo misurato (1-1,3 s dal sito); oltre, la persona vede il motivo e
 * «Riprova».
 *
 * Cosa conta come «la risposta non e' arrivata» lo dice `eDiRete` di
 * invioConTentativi.js (rete, 502, 503, 504), una copia sola: un 403 o un 400
 * non cambiano riprovando, e si dicono subito. Si riprovano solo le LETTURE:
 * una scrittura che si ripete da sola puo' scrivere due volte.
 */
import { eDiRete } from './invioConTentativi';
import { messaggioDa } from './notifiche';

/* Un oggetto e non una costante: la prova accorcia l'attesa. */
export const ATTESA_PRIMA_LETTURA = { ms: 2000 };

const pausa = (ms) => new Promise((r) => setTimeout(r, ms));

/**
 * Esegue `lettura()`; se fallisce perche' la risposta non e' arrivata,
 * aspetta ATTESA_PRIMA_LETTURA.ms e la rifa' una volta. Solleva l'ultimo
 * errore.
 */
export async function conUnTentativo(lettura) {
    try {
        return await lettura();
    } catch (e) {
        if (!eDiRete(e)) throw e;
        /* Zero (le prove) vuol dire subito, senza passare da un timer: con i
           timer finti di jest un setTimeout(0) aspetterebbe un avanzamento. */
        if (ATTESA_PRIMA_LETTURA.ms > 0) await pausa(ATTESA_PRIMA_LETTURA.ms);
        return lettura();
    }
}

/**
 * Il testo da mostrare quando la prima lettura non e' riuscita neanche al
 * secondo tentativo: se la risposta non e' arrivata lo si dice in italiano
 * («Network Error» di axios non lo e'), altrimenti il motivo del server
 * (messaggioDa), col ripiego della pagina.
 */
export function motivoDellaLettura(e, ripiego) {
    if (eDiRete(e)) return `${ripiego}: il server non ha risposto. Riprova fra qualche secondo.`;
    return messaggioDa(e, ripiego);
}
